import subMinutes from 'date-fns/subMinutes'
import { DateTime, isInBetween, toDate } from '../../utils/datetime'

export const getIsNow = (startsAt: DateTime, endsAt: DateTime) => isInBetween(
    toDate(startsAt), toDate(endsAt), new Date(),
)
export const getIsSoon = (startsAt: DateTime) => isInBetween(
    subMinutes(toDate(startsAt), 5), toDate(startsAt), new Date(),
)
